import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SocialSharingUtilsService } from './social-sharing-utils.service';

@Component({
  selector: 'ut-social-sharing-popover',
  templateUrl: './social-sharing-popover.component.html',
  styleUrls: ['./social-sharing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SocialSharingPopoverComponent {
  target!: string;
  text!: string;
  isLightTester!: boolean;
  checkLightTester!: (event: Event) => void;

  constructor(private socialSharingUtils: SocialSharingUtilsService) {}

  getTwitterUrl(): string {
    return this.socialSharingUtils.getTwitterUrl(this.text, this.target);
  }

  getLinkedInUrl(): string {
    return this.socialSharingUtils.getLinkedInUrl(this.text, this.target);
  }

  openUrl(url: string): void {
    this.socialSharingUtils.openSocialPopup(url);
  }
}
